import { SettingsLayout } from "./layout"
import { Section } from "./index"
import { Checkbox } from "@/components/ui/checkbox"
import { Label } from "@/components/ui/label"
import { SidebarExpandDisabledState } from "@/app/sidebar_prefs"
import { usePageTitle } from "@/utils"

/** Personal, device-local display preferences (stored in localStorage, not on the server). */
export function SettingsPreferences() {
  usePageTitle("Preferences")
  return (
    <SettingsLayout>
      <SidebarSection />
    </SettingsLayout>
  )
}

function SidebarSection() {
  const expand_disabled = SidebarExpandDisabledState.use()
  return (
    <Section title="Sidebar" class="bg-white rounded-lg shadow-sm p-6">
      <div class="flex items-start gap-3">
        <Checkbox
          id="sidebar-expand-disabled"
          checked={expand_disabled}
          onCheckedChange={(checked: boolean | "indeterminate") => SidebarExpandDisabledState.set(checked === true)}
        />
        <div class="space-y-1">
          <Label htmlFor="sidebar-expand-disabled" class="cursor-pointer">
            Keep the sidebar collapsed
          </Label>
          <p class="text-sm text-gray-500">
            The sidebar stays a narrow icon rail and never expands on hover. Subpages remain
            reachable via the dots under each icon. This preference is saved on this device only.
          </p>
        </div>
      </div>
    </Section>
  )
}
